exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-box[data-v-6ef16b8c] {\n  padding: 30px 30px 0;\n}\n", ""]);

// exports
